/* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-07. Code Start */
/**
 * Chapter root overview pages: menu slug → display config.
 * pagePath is the menu slug; resolvePagePath() maps to legacy pageInformation keys.
 */
/* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
import { CAPSTONE_FOLDER_OVERVIEW_HTML } from "./capstone/lib/config";
/* Code end. ray using AI Agent. 2026-09-24 */

export const CHAPTER_ROOT_PAGES = {
  "ch-1-foundation-years-1950s-2010s": {
    pageName: "Ch 1: Foundation Years (1950s-2010s)",
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s",
    /* Code end. ray using AI Agent. 2026-07-13 */
    /* Code end. ray using AI Agent. 2026-07-10 */
    videoSrc: "videos/SEL-197 Attach Video to 'NLP Foundational Knowledge' Description page.mp4",
    captionsSrc: "subtitles/SEL-197 Attach Video to 'NLP Foundational Knowledge' Description page-caption.srt",
    showVideoToggle: true,
  },
  "ch-2-pre-transformer-dl-2012-2017": {
    pageName: "Ch 2: Pre-Transformer DL (2012-2017)",
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-2-pre-transformer-dl-2012-2017",
    /* Code end. ray using AI Agent. 2026-07-14 */
    /* Code end. ray using AI Agent. 2026-07-10 */
    videoSrc: "videos/neuralnetworks.mp4",
    captionsSrc: "subtitles/neuralnetworks.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018": {
    pageName: "Ch 3: Transformer Revolution (2017-2018)",
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018",
    /* Code end. ray using AI Agent. 2026-07-14 */
    /* Code end. ray using AI Agent. 2026-07-10 */
    videoSrc: "videos/transormerdesc.mp4",
    captionsSrc: "subtitles/transformers.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present": {
    pageName: "Ch 4: Age of LLMs (2019-Present)",
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    pagePath: "ch-4-age-of-llms-2019-present",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Code end. ray using AI Agent. 2026-07-10 */
    videoSrc: "videos/LLMs Description.mp4",
    captionsSrc: "subtitles/SEL-122 Large Language Models-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms": {
    pageName: "Ch 5: Working with LLMs",
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-5-working-with-llms",
    /* Code end. ray using AI Agent. 2026-07-13 */
    /* Code end. ray using AI Agent. 2026-07-10 */
    videoSrc: "videos/Prompt Engineering Description Page.mp4",
    captionsSrc: "subtitles/Prompt Engineering Description Page-caption.srt",
    showVideoToggle: true,
  },
  "ch-6-model-improvement-explainability-safety": {
    pageName: "Ch 6: Model Improvement, Explainability & Safety",
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    pagePath: "ch-6-model-improvement-explainability-safety",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Code end. ray using AI Agent. 2026-07-10 */
    videoSrc: "videos/modelImprovtechn.mp4",
    captionsSrc: "subtitles/modelimprtech.srt",
    showVideoToggle: true,
  },
  "ch-7-real-world-applications": {
    pageName: "Ch 7: Real-World Applications",
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    pagePath: "ch-7-real-world-applications",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Code end. ray using AI Agent. 2026-07-10 */
    videoSrc: "videos/Industry Applicationsof NLP.mp4",
    captionsSrc: "subtitles/SEL-203 Industry Applications of NLP-caption.srt",
    showVideoToggle: true,
  },
};

/* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
/**
 * Folder overview pages: menu slug → display config (video, title).
 * pageInformation content is resolved via pagePathAliases.json.
 */
export const FOLDER_ROOT_PAGES = {
  /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
  "ch-1-foundation-years-1950s-2010s-11-what-is-nlp": {
    pageName: "1.1 What is NLP?",
    pagePath: "nlp-foundation",
    videoSrc: "videos/SEL-197 Attach Video to 'NLP Foundational Knowledge' Description page.mp4",
    captionsSrc: "subtitles/SEL-197 Attach Video to 'NLP Foundational Knowledge' Description page-caption.srt",
    showVideoToggle: true,
  },
  /* Commenting the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Comment Start */
  // "ch-1-foundation-years-1950s-2010s-12-applications-of-nlp": {
  //   pageName: "1.2 Applications of NLP",
  //   pagePath: "ch-1-foundation-years-1950s-2010s-12-applications-of-nlp",
  //   videoSrc: "videos/applofnlp.mp4",
  //   captionsSrc: "subtitles/applofnlp.srt",
  //   showVideoToggle: true,
  // },
  /* Commenting end. ray using AI Agent. 2026-08-24 */
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp": {
    /* Added the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Code Start */
    pageName: "1.2 The Five Eras of NLP",
    /* Code end. ray using AI Agent. 2026-08-24 */
    /* Commenting the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Comment Start */
    // pageName: "1.3 The Five Eras of NLP",
    /* Commenting end. ray using AI Agent. 2026-08-24 */
    pagePath: "approaches-to-NLP",
    videoSrc: "videos/Approaches to NLP.mp4",
    captionsSrc: "subtitles/SEL-41 Approaches to NLP-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-1-rule-based-1950s1990s": {
    pageName: "Era 1: Rule-Based (1950s-1990s)",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-1-rule-based-1950s1990s",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/Heuristic Based.mp4",
    captionsSrc: "subtitles/SEL-43 Heuristic Based -caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-1-rule-based-1950s1990s-heuristics-based": {
    pageName: "Heuristics-based",
    pagePath: "heuristic-based",
    videoSrc: "videos/Heuristic Based.mp4",
    captionsSrc: "subtitles/SEL-43 Heuristic Based -caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-1-rule-based-1950s1990s-heuristics-based-methods": {
    pageName: "Methods",
    pagePath: "methods",
    videoSrc: "videos/Methods.mp4",
    captionsSrc: "subtitles/SEL-198 Methods-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-2-statistical-nlp-1990s2000s": {
    pageName: "Era 2: Statistical NLP (1990s-2000s)",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-2-statistical-nlp-1990s2000s",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/Feature Engineering.mp4",
    captionsSrc: "subtitles/Feature Engineering-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-2-statistical-nlp-1990s2000s-feature-engineering": {
    pageName: "Feature Engineering",
    pagePath: "feature-engineering",
    videoSrc: "videos/Feature Engineering.mp4",
    captionsSrc: "subtitles/Feature Engineering-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-2-statistical-nlp-1990s2000s-feature-engineering-basic-vectorization-approaches": {
    pageName: "Basic Vectorization Approaches",
    pagePath: "basic-vectorization",
    videoSrc: "videos/Basic Vectorization Approaches.mp4",
    captionsSrc: "subtitles/SEL-69 Basic Vectorization Approaches-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-3-ml-takes-over-2000s2010s": {
    pageName: "Era 3: ML Takes Over (2000s-2010s)",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-3-ml-takes-over-2000s2010s",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/Machine Learning based.mp4",
    captionsSrc: "subtitles/SEL-44 Machine Learning based-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-3-ml-takes-over-2000s2010s-machine-learning-based-nlp": {
    pageName: "Machine Learning-based NLP",
    pagePath: "mlbased-NLP",
    videoSrc: "videos/Machine Learning based.mp4",
    captionsSrc: "subtitles/SEL-44 Machine Learning based-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-3-ml-takes-over-2000s2010s-machine-learning-based-nlp-types": {
    pageName: "Types",
    pagePath: "types",
    videoSrc: "videos/Types.mp4",
    captionsSrc: "subtitles/SEL-114 Types-caption.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-4-neural-revolution-20102017": {
    pageName: "Era 4: Neural Revolution (2010-2017)",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-4-neural-revolution-20102017",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/deeplearn.mp4",
    captionsSrc: "subtitles/deeplearnbased.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-4-neural-revolution-20102017-deep-learning-based-nlp": {
    pageName: "Deep Learning-based NLP",
    pagePath: "dlbased-NLP",
    videoSrc: "videos/deeplearn.mp4",
    captionsSrc: "subtitles/deeplearnbased.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-4-neural-revolution-20102017-deep-learning-based-nlp-neural-networks": {
    pageName: "Neural Networks",
    /* Remapped folder hub to own slug for unique Test it. Ray_testit. ray using AI Agent. 2026-07-15. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-4-neural-revolution-20102017-deep-learning-based-nlp-neural-networks",
    /* Code end. ray using AI Agent. 2026-07-15 */
    videoSrc: "videos/neuralnetworks.mp4",
    captionsSrc: "subtitles/neuralnetworks.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-5-transformer-breakthrough-20172018": {
    pageName: "Era 5: Transformer Breakthrough (2017-2018)",
    /* Remapped folder hub to own slug for unique Test it. Ray_testit. ray using AI Agent. 2026-07-15. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-5-transformer-breakthrough-20172018",
    /* Code end. ray using AI Agent. 2026-07-15 */
    videoSrc: "videos/transormerdesc.mp4",
    captionsSrc: "subtitles/transformers.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-5-transformer-breakthrough-20172018-transformers": {
    pageName: "Transformers",
    /* Remapped folder hub to own slug for unique Test it. Ray_testit. ray using AI Agent. 2026-07-15. Code Start */
    pagePath: "ch-1-foundation-years-1950s-2010s-13-the-five-eras-of-nlp-era-5-transformer-breakthrough-20172018-transformers",
    /* Code end. ray using AI Agent. 2026-07-15 */
    videoSrc: "videos/transormerdesc.mp4",
    captionsSrc: "subtitles/transformers.srt",
    showVideoToggle: true,
  },
  "ch-1-foundation-years-1950s-2010s-14-the-nlp-pipeline": {
    /* Added the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Code Start */
    pageName: "1.3 The NLP Pipeline",
    /* Code end. ray using AI Agent. 2026-08-24 */
    /* Commenting the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Comment Start */
    // pageName: "1.4 The NLP Pipeline",
    /* Commenting end. ray using AI Agent. 2026-08-24 */
    pagePath: "nlp-pipeline",
    videoSrc: "videos/NLP Pipeline.mp4",
    captionsSrc: "subtitles/NLP Pipeline-caption.srt",
    showVideoToggle: true,
  },
  /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start (Ch 2-7) */
  "ch-2-pre-transformer-dl-2012-2017": {
    pageName: "Ch 2: Pre-Transformer DL (2012-2017)",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-2-pre-transformer-dl-2012-2017",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/neuralnetworks.mp4",
    captionsSrc: "subtitles/neuralnetworks.srt",
    showVideoToggle: true,
  },
  "ch-2-pre-transformer-dl-2012-2017-21-neural-networks-basics": {
    pageName: "2.1 Neural Networks Basics",
    /* Remapped narrative folder to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-2-pre-transformer-dl-2012-2017-21-neural-networks-basics",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/neuralnetworks.mp4",
    captionsSrc: "subtitles/neuralnetworks.srt",
    showVideoToggle: true,
  },
  "ch-2-pre-transformer-dl-2012-2017-22-cnns-for-text": {
    pageName: "2.2 CNNs for Text",
    /* Remapped folder hub to own slug for unique Test it. Ray_testit. ray using AI Agent. 2026-07-15. Code Start */
    pagePath: "ch-2-pre-transformer-dl-2012-2017-22-cnns-for-text",
    /* Code end. ray using AI Agent. 2026-07-15 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/CNN.mp4",
    captionsSrc: "subtitles/cnn.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-2-pre-transformer-dl-2012-2017-23-rnns-lstms": {
    pageName: "2.3 RNNs & LSTMs",
    /* Remapped folder hub to own slug for unique Test it. Ray_testit. ray using AI Agent. 2026-07-15. Code Start */
    pagePath: "ch-2-pre-transformer-dl-2012-2017-23-rnns-lstms",
    /* Code end. ray using AI Agent. 2026-07-15 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/RNN.mp4",
    captionsSrc: "subtitles/rnn.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-2-pre-transformer-dl-2012-2017-24-attention-mechanism-2014": {
    pageName: "2.4 Attention Mechanism (2014)",
    /* Remapped folder hub to own slug for unique Test it. Ray_testit. ray using AI Agent. 2026-07-15. Code Start */
    pagePath: "ch-2-pre-transformer-dl-2012-2017-24-attention-mechanism-2014",
    /* Code end. ray using AI Agent. 2026-07-15 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/selfattention.mp4",
    captionsSrc: "subtitles/selfattention.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-2-pre-transformer-dl-2012-2017-25-limitations-that-led-to-transformers": {
    pageName: "2.5 Limitations That Led to Transformers",
    /* Remapped narrative folder to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-2-pre-transformer-dl-2012-2017-25-limitations-that-led-to-transformers",
    /* Code end. ray using AI Agent. 2026-07-14 */
    /* Commenting the following code for video.ray using AI Agent. 03/09/2026. Comment Start */
    // Borrowed Ch 3 Transformers video — not a 2.5 topic asset.
    // videoSrc: "videos/transormerdesc.mp4",
    // captionsSrc: "subtitles/transformers.srt",
    // showVideoToggle: true,
    /* Commenting end. ray using AI Agent. 03/09/2026 */
  },
  "ch-3-transformer-revolution-2017-2018": {
    pageName: "Ch 3: Transformer Revolution (2017-2018)",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/transormerdesc.mp4",
    captionsSrc: "subtitles/transformers.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018-31-attention-is-all-you-need-2017": {
    /* Added the following code for menu_cleanup.ray using AI Agent. 01/09/2026. Code Start */
    pageName: "3.1 Introducing Transformers",
    /* Code end. ray using AI Agent. 01/09/2026 */
    /* Commenting the following code for menu_cleanup.ray using AI Agent. 01/09/2026. Comment Start */
    // pageName: "3.1 Attention Is All You Need (2017)",
    /* Commenting end. ray using AI Agent. 01/09/2026 */
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-31-attention-is-all-you-need-2017",
    /* Code end. ray using AI Agent. 2026-07-14 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/selfattention.mp4",
    captionsSrc: "subtitles/selfattention.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-3-transformer-revolution-2017-2018-32-transformer-architecture-deep-dive": {
    pageName: "3.2 Transformer Architecture Deep Dive",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-32-transformer-architecture-deep-dive",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/transormerdesc.mp4",
    captionsSrc: "subtitles/transformers.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018-32-transformer-architecture-deep-dive-transformers-full-stack": {
    pageName: "Transformers (full stack)",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-32-transformer-architecture-deep-dive-transformers-full-stack",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/transormerdesc.mp4",
    captionsSrc: "subtitles/transformers.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018-32-transformer-architecture-deep-dive-exploring-pre-llms-bert": {
    pageName: "Exploring Pre-LLMs (BERT)",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-32-transformer-architecture-deep-dive-exploring-pre-llms-bert",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/exploringbert.mp4",
    captionsSrc: "subtitles/explorebert.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018-33-bert-bidirectional-understanding": {
    pageName: "3.3 BERT: Bidirectional Understanding",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-33-bert-bidirectional-understanding",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/exploringbert.mp4",
    captionsSrc: "subtitles/explorebert.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018-33-bert-bidirectional-understanding-exploring-pre-llms-bert": {
    pageName: "Exploring Pre-LLMs (BERT)",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-33-bert-bidirectional-understanding-exploring-pre-llms-bert",
    /* Code end. ray using AI Agent. 2026-07-14 */
    videoSrc: "videos/exploringbert.mp4",
    captionsSrc: "subtitles/explorebert.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018-33-bert-bidirectional-understanding-exploring-pre-llms-bert-input-data-preparation": {
    pageName: "Input Data Preparation",
    pagePath: "input-data-preparation",
    videoSrc: "videos/inputdatapreparation.mp4",
    captionsSrc: "subtitles/inputdatapre.srt",
    showVideoToggle: true,
  },
  "ch-3-transformer-revolution-2017-2018-34-gpt-generative-pre-training-2018": {
    pageName: "3.4 GPT: Generative Pre-training (2018)",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-34-gpt-generative-pre-training-2018",
    /* Code end. ray using AI Agent. 2026-07-14 */
    /* Commenting the following code for video.ray using AI Agent. 03/09/2026. Comment Start */
    // Borrowed Ch 4 All about LLMs video — not a 3.4 topic asset.
    // videoSrc: "videos/All about LLMs.mp4",
    // captionsSrc: "subtitles/SEL-116 All about LLMs-caption.srt",
    // showVideoToggle: true,
    /* Commenting end. ray using AI Agent. 03/09/2026 */
  },
  "ch-3-transformer-revolution-2017-2018-35-why-this-changed-everything": {
    pageName: "3.5 Why This Changed Everything",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
    pagePath: "ch-3-transformer-revolution-2017-2018-35-why-this-changed-everything",
    /* Code end. ray using AI Agent. 2026-07-14 */
    /* Commenting the following code for video.ray using AI Agent. 03/09/2026. Comment Start */
    // Borrowed Ch 3 Transformers video — not a 3.5 topic asset.
    // videoSrc: "videos/transormerdesc.mp4",
    // captionsSrc: "subtitles/transformers.srt",
    // showVideoToggle: true,
    /* Commenting end. ray using AI Agent. 03/09/2026 */
  },
  "ch-4-age-of-llms-2019-present-41-what-are-llms": {
    pageName: "4.1 What Are LLMs?",
    pagePath: "ch-4-age-of-llms-2019-present-41-what-are-llms",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    videoSrc: "videos/All about LLMs.mp4",
    captionsSrc: "subtitles/SEL-116 All about LLMs-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-42-scaling-laws-why-size-matters": {
    pageName: "4.2 Scaling Laws: Why Size Matters",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-4-age-of-llms-2019-present-42-scaling-laws-why-size-matters",
    /* Code end. ray using AI Agent. 2026-07-13 */
    /* Commenting the following code for vidremap.ray using AI Agent. 2026-07-21. Comment Start */
    // videoSrc: "videos/Success Factors of LLMs.mp4",
    // captionsSrc: "subtitles/SEL-124 Success Factors of LLMs-caption.srt",
    /* Commenting end. ray using AI Agent. 2026-07-21 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/Scaling Laws.mp4",
    captionsSrc: "subtitles/SEL-125 Scaling Laws-caption.srt",
    /* Code end. ray using AI Agent. 2026-07-21 */
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-42-scaling-laws-why-size-matters-success-factors-of-llms": {
    pageName: "Success Factors of LLMs",
    pagePath: "success-factors-of-llms",
    videoSrc: "videos/Success Factors of LLMs.mp4",
    captionsSrc: "subtitles/SEL-124 Success Factors of LLMs-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale": {
    pageName: "4.3 Pre-Training at Scale",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-4-age-of-llms-2019-present-43-pre-training-at-scale",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/Pre-Training Pipeline.mp4",
    captionsSrc: "subtitles/Pre-Training Pipeline-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale-history-of-llms": {
    pageName: "History of LLMs",
    pagePath: "history-of-llms",
    videoSrc: "videos/History of LLMs.mp4",
    captionsSrc: "subtitles/SEL-118 History of LLMs-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale-pre-training-pipeline": {
    pageName: "Pre-Training Pipeline",
    pagePath: "pre-training-pipeline",
    videoSrc: "videos/Pre-Training Pipeline.mp4",
    captionsSrc: "subtitles/Pre-Training Pipeline-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale-pre-training-pipeline-data-collection-and-preparation": {
    pageName: "Data Collection and Preparation",
    pagePath: "data-collection-and-preparation",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/Data Collection.mp4",
    captionsSrc: "subtitles/SEL-155 Data Collection and Preparation-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale-pre-training-pipeline-configuration-considerations": {
    pageName: "Configuration Considerations",
    pagePath: "configuration-considerations-pretraining",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/configurations.mp4",
    captionsSrc: "subtitles/configcons.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale-pre-training-pipeline-pre-training-tasks": {
    pageName: "Pre-Training Tasks",
    pagePath: "pre-training-tasks",
    videoSrc: "videos/pretrainingtasks.mp4",
    captionsSrc: "subtitles/pretraintasks.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale-pre-training-pipeline-pre-training-tasks-long-context-modeling": {
    pageName: "Long-context Modeling",
    pagePath: "long-context-modeling",
    videoSrc: "videos/longcontextmodel.mp4",
    captionsSrc: "subtitles/longcntxtmodel.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-43-pre-training-at-scale-pre-training-pipeline-pre-training-tasks-model-training-considerations": {
    pageName: "Model Training Considerations",
    pagePath: "model-training-considerations",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/Training.mp4",
    captionsSrc: "subtitles/SEL-126 Training-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-44-fine-tuning-strategies": {
    pageName: "4.4 Fine-Tuning Strategies",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-4-age-of-llms-2019-present-44-fine-tuning-strategies",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/finetunellms.mp4",
    captionsSrc: "subtitles/finetunellmn.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-44-fine-tuning-strategies-fine-tuning-llms": {
    pageName: "Fine-Tuning LLMs",
    pagePath: "finetuning-llms",
    videoSrc: "videos/finetunellms.mp4",
    captionsSrc: "subtitles/finetunellmn.srt",
    showVideoToggle: true,
  },
  /* Commenting the following code for menu_cleanup.ray using AI Agent. 01/09/2026. Comment Start */
  // "ch-4-age-of-llms-2019-present-45-alignment-tuning-rlhf": {
  //   pageName: "4.5 Alignment Tuning (RLHF)",
  //   pagePath: "ch-4-age-of-llms-2019-present-45-alignment-tuning-rlhf",
  //   /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
  //   /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
  //   videoSrc: "videos/Alignment Tuning.mp4",
  //   captionsSrc: "subtitles/SEL-128 Alignment Tuning -caption.srt",
  //   showVideoToggle: true,
  //   /* Code end. ray using AI Agent. 2026-07-21 */
  // },
  /* Commenting end. ray using AI Agent. 01/09/2026 */
  "ch-4-age-of-llms-2019-present-46-major-llm-families": {
    pageName: "4.5 Major LLM Families",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-4-age-of-llms-2019-present-46-major-llm-families",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/LLM Resources Description.mp4",
    captionsSrc: "subtitles/SEL-129 LLM Resources Description-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-46-major-llm-families-llm-resources": {
    pageName: "LLM Resources",
    pagePath: "llm-resources",
    videoSrc: "videos/LLM Resources Description.mp4",
    captionsSrc: "subtitles/SEL-129 LLM Resources Description-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-46-major-llm-families-llm-resources-open-source-llms": {
    pageName: "Open Source LLMs",
    pagePath: "open-source-llms",
    videoSrc: "videos/Open Source LLMs Description.mp4",
    captionsSrc: "subtitles/SEL-130 Open Source LLMs Description-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-46-major-llm-families-llm-resources-datasets-for-fine-tuning": {
    pageName: "Datasets for Fine-Tuning",
    pagePath: "datasets-for-finetuning",
    videoSrc: "videos/Datasets for Fine-tuning.mp4",
    captionsSrc: "subtitles/SEL-137 Datasets for Fine-tuning-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-46-major-llm-families-llm-resources-resources-for-llm-development": {
    pageName: "Resources for LLM Development",
    pagePath: "resources-for-llm-developments",
    videoSrc: "videos/Resources for LLM Development.mp4",
    captionsSrc: "subtitles/SEL-142 Resources for LLM Development-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-47-model-evaluation": {
    pageName: "4.6 Model Evaluation",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-4-age-of-llms-2019-present-47-model-evaluation",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/modelevaluation.mp4",
    captionsSrc: "subtitles/modeleva.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-47-model-evaluation-model-evaluation": {
    pageName: "Model Evaluation",
    pagePath: "model-evaluation",
    videoSrc: "videos/modelevaluation.mp4",
    captionsSrc: "subtitles/modeleva.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-47-model-evaluation-model-evaluation-evaluating-basic-abilities": {
    pageName: "Evaluating Basic Abilities",
    pagePath: "basic-abilities",
    videoSrc: "videos/evaluatingbasicabilities.mp4",
    captionsSrc: "subtitles/evabasicabilities.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-47-model-evaluation-model-evaluation-evaluating-basic-abilities-language-generation": {
    pageName: "Language Generation",
    /* Remapped folder hub to own slug for unique Test it. Ray_testit. ray using AI Agent. 2026-07-15. Code Start */
    pagePath: "ch-4-age-of-llms-2019-present-47-model-evaluation-model-evaluation-evaluating-basic-abilities-language-generation",
    /* Code end. ray using AI Agent. 2026-07-15 */
    videoSrc: "videos/languagegeneration.mp4",
    captionsSrc: "subtitles/languagegen.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-47-model-evaluation-model-evaluation-evaluating-basic-abilities-knowledge-utilization": {
    pageName: "Knowledge Utilization",
    pagePath: "knowledge-utilization",
    videoSrc: "videos/knowledgeutitlization.mp4",
    captionsSrc: "subtitles/knowledgeutilization.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-47-model-evaluation-model-evaluation-evaluating-advanced-abilities": {
    pageName: "Evaluating Advanced Abilities",
    pagePath: "advance-abilities",
    videoSrc: "videos/evaadvancedabilities.mp4",
    captionsSrc: "subtitles/evaadvabilities.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-47-model-evaluation-model-evaluation-benchmark-and-evaluation": {
    pageName: "Benchmark and Evaluation",
    pagePath: "benchmark-evaluation",
    videoSrc: "videos/benchmarkeva.mp4",
    captionsSrc: "subtitles/benchevaapp.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms": {
    pageName: "4.7 Applications of LLMs",
    pagePath: "ch-4-age-of-llms-2019-present-48-applications-of-llms",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/llmIRA.mp4",
    captionsSrc: "subtitles/llmIRA.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research": {
    pageName: "LLM Improvement Research",
    pagePath: "llm-improvement-Research-Areas",
    videoSrc: "videos/llmIRA.mp4",
    captionsSrc: "subtitles/llmIRA.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-classic-nlp-areas": {
    pageName: "Classic NLP Areas",
    pagePath: "classic-nlptasks",
    videoSrc: "videos/classicNLPtasks.mp4",
    captionsSrc: "subtitles/classicNLPtasks.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-classic-nlp-areas-nlp-tasks": {
    pageName: "NLP Tasks",
    pagePath: "nlp-tasks",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/NLPtasks.mp4",
    captionsSrc: "subtitles/NLPtasks.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-classic-nlp-areas-llm-for-ir": {
    pageName: "LLM for IR",
    pagePath: "llm-for-ir",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/llmasIR.mp4",
    captionsSrc: "subtitles/llmasIR.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-classic-nlp-areas-llm-for-recommenders": {
    pageName: "LLM for Recommenders",
    pagePath: "llm-for-recommenders",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/recommendersystems.mp4",
    captionsSrc: "subtitles/SEL-10 Product recommendations-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-enhancing-llms": {
    pageName: "Enhancing LLMs",
    pagePath: "enhancing-llms",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/multimodelllm.mp4",
    captionsSrc: "subtitles/multimodelllm.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-enhancing-llms-multi-modal-llms": {
    pageName: "Multi-modal LLMs",
    pagePath: "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-enhancing-llms-multi-modal-llms",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/multimodelllm.mp4",
    captionsSrc: "subtitles/multimodelllm.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-enhancing-llms-kg-enhanced-llm": {
    pageName: "KG Enhanced LLM",
    pagePath: "knowledge-graph-enhanced-llm",
    videoSrc: "videos/KnowledgeGraph.mp4",
    /* Commenting the following code for vidremap.ray using AI Agent. 2026-07-21. Comment Start */
    // captionsSrc: "subtitles/SEL-105 Knowledge Graph Enhanced LLM-caption.srt",
    /* Commenting end. ray using AI Agent. 2026-07-21 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    captionsSrc: "subtitles/KnowledgeGraph-caption.srt",
    /* Code end. ray using AI Agent. 2026-07-21 */
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-new-capabilities": {
    pageName: "New Capabilities",
    pagePath: "new-capabilities",
    videoSrc: "videos3/New Capabilities.mp4",
    captionsSrc: "videos3/New Capabilities-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-new-capabilities-llm-based-agent": {
    pageName: "LLM-based Agent",
    pagePath: "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-new-capabilities-llm-based-agent",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    videoSrc: "videos3/SEL-264 Attach Video to LLM-Based Agent for Description page.mp4",
    captionsSrc: "videos3/SEL-264 Attach Video to LLM-Based Agent for Description page-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-llm-improvement-research-new-capabilities-llm-for-evaluation": {
    pageName: "LLM for Evaluation",
    pagePath: "llm-for-evaluation",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/SEL-267 Attach Video to LLM For Evaluation for Description page.mp4",
    captionsSrc: "subtitles/SEL-267 Attach Video to LLM For Evaluation for Description page-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-4-age-of-llms-2019-present-48-applications-of-llms-domain-applications": {
    pageName: "Domain Applications",
    pagePath: "domain-applications",
    videoSrc: "videos3/SEL-271 Attach Video to Domain Applications for Description Page.mp4",
    captionsSrc: "videos3/SEL-271 Attach Video to Domain Applications for Description Page-caption.srt",
    showVideoToggle: true,
  },
  "ch-4-age-of-llms-2019-present-agents": {
    pageName: "4.8 Agents",
    pagePath: "agents",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/SEL-264 Attach Video to LLM-Based Agent for Description page.mp4",
    captionsSrc: "subtitles/SEL-264 Attach Video to LLM-Based Agent for Description page-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-5-working-with-llms-51-prompt-engineering-fundamentals": {
    pageName: "5.1 Prompt Engineering Fundamentals",
    pagePath: "ch-5-working-with-llms-51-prompt-engineering-fundamentals",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    videoSrc: "videos/Prompt Engineering Description Page.mp4",
    captionsSrc: "subtitles/Prompt Engineering Description Page-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-51-prompt-engineering-fundamentals-introduction-structure": {
    pageName: "Introduction & Structure",
    pagePath: "introduction-structure",
    videoSrc: "videos/SEL-206 Attach video to Introduction & Structure.mp4",
    captionsSrc: "subtitles/SEL-206 Attach video to Introduction & Structure-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-52-advanced-prompting": {
    pageName: "5.2 Advanced Prompting",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-5-working-with-llms-52-advanced-prompting",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/advancedprompting.mp4",
    captionsSrc: "subtitles/adnvancedprompt.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-52-advanced-prompting-methods-of-prompting": {
    pageName: "Methods of Prompting",
    pagePath: "methods-of-prompting",
    videoSrc: "videos/Methods of Prompting Description page.mp4",
    captionsSrc: "subtitles/SEL-210 Methods of Prompting Description page-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-52-advanced-prompting-methods-of-prompting-core-prompting": {
    pageName: "Core Prompting",
    pagePath: "core-prompting",
    videoSrc: "videos/Core Prompting.mp4",
    captionsSrc: "subtitles/SEL-211 Core Prompting-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-52-advanced-prompting-methods-of-prompting-core-prompting-role-playing-prompting": {
    pageName: "Role-Playing Prompting",
    pagePath: "role-playing-promptings",
    videoSrc: "videos/Role-Playing Prompting description page.mp4",
    captionsSrc: "subtitles/SEL-212 Role-Playing Prompting description page-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-52-advanced-prompting-methods-of-prompting-core-prompting-n-shot-prompting": {
    pageName: "N-Shot Prompting",
    pagePath: "n-shot-promptings",
    videoSrc: "videos/N-Shot Prompting.mp4",
    captionsSrc: "subtitles/SEL-216 Attach video to N-Shot Prompting description page-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-52-advanced-prompting-methods-of-prompting-advanced-prompting": {
    pageName: "Advanced Prompting",
    pagePath: "advanced-prompting",
    videoSrc: "videos/advancedprompting.mp4",
    captionsSrc: "subtitles/adnvancedprompt.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-52-advanced-prompting-methods-of-prompting-expert-prompting": {
    pageName: "Expert Prompting",
    pagePath: "expert-prompting",
    videoSrc: "videos/expertprompt.mp4",
    captionsSrc: "subtitles/expertprompt.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-53-rag": {
    pageName: "5.3 RAG",
    pagePath: "ch-5-working-with-llms-53-rag",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/retrievalaugllm.mp4",
    captionsSrc: "subtitles/retrievalaugllm.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-5-working-with-llms-54-llm-agents": {
    pageName: "5.4 LLM Agents",
    pagePath: "ch-5-working-with-llms-54-llm-agents",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    videoSrc: "videos3/SEL-264 Attach Video to LLM-Based Agent for Description page.mp4",
    captionsSrc: "videos3/SEL-264 Attach Video to LLM-Based Agent for Description page-caption.srt",
    showVideoToggle: true,
  },
  "ch-5-working-with-llms-55-multi-modal-llms": {
    pageName: "5.5 Multi-Modal LLMs",
    pagePath: "ch-5-working-with-llms-55-multi-modal-llms",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/multimodelllm.mp4",
    captionsSrc: "subtitles/multimodelllm.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  /* Commenting the following code for menu_cleanup.ray using AI Agent. 01/09/2026. Comment Start */
  // "ch-5-working-with-llms-56-classic-tasks-with-llms": {
  //   pageName: "5.6 Classic tasks with LLMs",
  //   pagePath: "ch-5-working-with-llms-56-classic-tasks-with-llms",
  //   /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
  //   /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
  //   videoSrc: "videos/classicNLPtasks.mp4",
  //   captionsSrc: "subtitles/classicNLPtasks.srt",
  //   showVideoToggle: true,
  //   /* Code end. ray using AI Agent. 2026-07-21 */
  // },
  /* Commenting end. ray using AI Agent. 01/09/2026 */
  "ch-6-model-improvement-explainability-safety-61-model-compression": {
    pageName: "6.1 Model Compression",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-6-model-improvement-explainability-safety-61-model-compression",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/modelImprovtechn.mp4",
    captionsSrc: "subtitles/modelimprtech.srt",
    showVideoToggle: true,
  },
  "ch-6-model-improvement-explainability-safety-61-model-compression-model-improvement-techniques": {
    pageName: "Model Improvement Techniques",
    pagePath: "ch-6-model-improvement-explainability-safety-61-model-compression-model-improvement-techniques",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    videoSrc: "videos/modelImprovtechn.mp4",
    captionsSrc: "subtitles/modelimprtech.srt",
    showVideoToggle: true,
  },
  "ch-6-model-improvement-explainability-safety-61-model-compression-model-improvement-techniques-model-size-reduction": {
    pageName: "Model Size Reduction",
    pagePath: "model-size-reduction",
  },
  /* Commenting the following code for menu_cleanup.ray using AI Agent. 01/09/2026. Comment Start */
  // "ch-6-model-improvement-explainability-safety-62-explainable-ai": {
  //   pageName: "6.2 Explainable AI",
  //   pagePath: "ch-6-model-improvement-explainability-safety-62-explainable-ai",
  //   /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
  //   videoSrc: "videos/modelImprovtechn.mp4",
  //   captionsSrc: "subtitles/modelimprtech.srt",
  //   showVideoToggle: true,
  // },
  /* Commenting end. ray using AI Agent. 01/09/2026 */
  "ch-6-model-improvement-explainability-safety-63-hallucination-mitigation": {
    pageName: "6.2 Hallucination Mitigation",
    pagePath: "ch-6-model-improvement-explainability-safety-63-hallucination-mitigation",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Commenting the following code for video.ray using AI Agent. 03/09/2026. Comment Start */
    // Borrowed Ch 5 Hallucination Prompting video — not a Ch 6 topic asset.
    // /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    // videoSrc: "videos/hallucination.mp4",
    // captionsSrc: "subtitles/hallucinationprmpt.srt",
    // showVideoToggle: true,
    // /* Code end. ray using AI Agent. 2026-07-21 */
    /* Commenting end. ray using AI Agent. 03/09/2026 */
  },
  "ch-6-model-improvement-explainability-safety-64-bias-ethics": {
    pageName: "6.3 Bias & Ethics",
    pagePath: "ch-6-model-improvement-explainability-safety-64-bias-ethics",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Commenting the following code for video.ray using AI Agent. 03/09/2026. Comment Start */
    // Borrowed Ch 5 Debiasing Prompting video — not a Ch 6 topic asset.
    // /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    // videoSrc: "videos/SEL-234 Attach video to Debiasing Prompting for What is it_.mp4",
    // captionsSrc: "subtitles/SEL-234 Attach video to Debiasing Prompting for What is it_-caption.srt",
    // showVideoToggle: true,
    // /* Code end. ray using AI Agent. 2026-07-21 */
    /* Commenting end. ray using AI Agent. 03/09/2026 */
  },
  "ch-6-model-improvement-explainability-safety-65-future-directions": {
    pageName: "6.4 Future Directions",
    pagePath: "ch-6-model-improvement-explainability-safety-65-future-directions",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Commenting the following code for video.ray using AI Agent. 03/09/2026. Comment Start */
    // Reused 6.1 Model Improvement Techniques video as a placeholder — not a Future Directions asset.
    // videoSrc: "videos/modelImprovtechn.mp4",
    // captionsSrc: "subtitles/modelimprtech.srt",
    // showVideoToggle: true,
    /* Commenting end. ray using AI Agent. 03/09/2026 */
  },
  "ch-7-real-world-applications-71-e-commerce-retail": {
    pageName: "7.1 E-commerce & Retail",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-7-real-world-applications-71-e-commerce-retail",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/EcommerceRetail.mp4",
    /* Commenting the following code for vidremap.ray using AI Agent. 2026-07-21. Comment Start */
    // captionsSrc: "subtitles/SEL-102 Ecommerce & Retail-caption.srt",
    /* Commenting end. ray using AI Agent. 2026-07-21 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    captionsSrc: "subtitles/SEL-17 Ecommerce & Retail -caption.srt",
    /* Code end. ray using AI Agent. 2026-07-21 */
    showVideoToggle: true,
  },
  /* Added the following code for capstone_7_8.ray using AI Agent. 10/09/2026. Code Start */
  /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
  /* Folder overview hub for 7.8 — same RootSubmenu / pageInformation flow as other subfolder roots.
     Served at /ch-7-…-78-… and /your-capstone-project. Interactive UI remains at /capstone-hub. */
  "ch-7-real-world-applications-78-your-capstone-project": {
    pageName: "7.8 Your Capstone Project",
    pagePath: "ch-7-real-world-applications-78-your-capstone-project",
    /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
    /* Learner-facing SDLC overview when CMS is empty / still Default Content. */
    defaultWhatIsIt: CAPSTONE_FOLDER_OVERVIEW_HTML,
    /* Code end. ray using AI Agent. 2026-09-24 */
    /* Commenting the following code for caps.ray using AI Agent. 2026-09-24. Comment Start */
    // Self-referential CTA removed — hubs match other folders (CMS narrative only).
    // ctaPath: "/your-capstone-project",
    // ctaLabel: "Open Capstone Overview",
    /* Commenting end. ray using AI Agent. 2026-09-24 */
  },
  /* Code end. ray using AI Agent. 2026-09-24 */
  /* Code end. ray using AI Agent. 10/09/2026 */  "ch-7-real-world-applications-71-e-commerce-retail-ecommerce-retail": {
    pageName: "Ecommerce & Retail",
    pagePath: "ecommerce-retail",
    videoSrc: "videos/EcommerceRetail.mp4",
    /* Commenting the following code for vidremap.ray using AI Agent. 2026-07-21. Comment Start */
    // captionsSrc: "subtitles/SEL-102 Ecommerce & Retail-caption.srt",
    /* Commenting end. ray using AI Agent. 2026-07-21 */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    captionsSrc: "subtitles/SEL-17 Ecommerce & Retail -caption.srt",
    /* Code end. ray using AI Agent. 2026-07-21 */
    showVideoToggle: true,
  },
  "ch-7-real-world-applications-72-healthcare": {
    pageName: "7.2 Healthcare",
    pagePath: "ch-7-real-world-applications-72-healthcare",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/SEL-11 Healthcare.mp4",
    captionsSrc: "subtitles/SEL-11 Health Care-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-73-finance": {
    pageName: "7.3 Finance",
    pagePath: "ch-7-real-world-applications-73-finance",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/SEL-15 Finance.mp4",
    captionsSrc: "subtitles/SEL-51 Finance-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-74-legal-compliance": {
    pageName: "7.4 Legal & Compliance",
    pagePath: "ch-7-real-world-applications-74-legal-compliance",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/SEL-36Law.mp4",
    captionsSrc: "subtitles/SEL-36 Law-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-75-education": {
    pageName: "7.5 Education",
    pagePath: "ch-7-real-world-applications-75-education",
    /* Remapped parent to own slug for unique narrative. ray_menuStructure.ray. ray using AI Agent. 2026-07-14. */
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/SEL-276 Education.mp4",
    captionsSrc: "subtitles/SEL-276 Education-caption.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-76-broader-nlp-tasks": {
    pageName: "7.6 Broader NLP tasks",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-7-real-world-applications-76-broader-nlp-tasks",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/SEL-106 Industry Applications NLP.mp4",
    captionsSrc: "subtitles/SEL-106 Broader Tasks of NLP-caption.srt",
    showVideoToggle: true,
  },
  "ch-7-real-world-applications-76-broader-nlp-tasks-broader-tasks-of-nlp": {
    pageName: "Broader Tasks of NLP",
    pagePath: "Broader Tasks of NLP",
    videoSrc: "videos/SEL-106 Industry Applications NLP.mp4",
    captionsSrc: "subtitles/SEL-106 Broader Tasks of NLP-caption.srt",
    showVideoToggle: true,
  },
  "ch-7-real-world-applications-76-broader-nlp-tasks-broader-tasks-of-nlp-text-classification": {
    pageName: "Text Classification",
    pagePath: "text-classification",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/Textclassification.mp4",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-76-broader-nlp-tasks-broader-tasks-of-nlp-information-extraction-ie": {
    pageName: "Information Extraction (IE)",
    pagePath: "information-extraction-IE",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/informationextractionIE.mp4",
    captionsSrc: "subtitles/informationextra.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-76-broader-nlp-tasks-broader-tasks-of-nlp-topic-modeling": {
    pageName: "Topic Modeling",
    pagePath: "topic-modeling",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/topicmodeling.mp4",
    captionsSrc: "subtitles/topicmodeling.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-76-broader-nlp-tasks-broader-tasks-of-nlp-text-summarization": {
    pageName: "Text Summarization",
    pagePath: "text-summarization",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/textsummarization.mp4",
    captionsSrc: "subtitles/txtsummarization.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-76-broader-nlp-tasks-broader-tasks-of-nlp-search-and-match": {
    pageName: "Search and Match",
    pagePath: "search-match",
    /* Added the following code for vidremap.ray using AI Agent. 2026-07-21. Code Start */
    videoSrc: "videos/searchmatch.mp4",
    captionsSrc: "subtitles/searchnmatch.srt",
    showVideoToggle: true,
    /* Code end. ray using AI Agent. 2026-07-21 */
  },
  "ch-7-real-world-applications-77-social-customer-facing-nlp": {
    pageName: "7.7 Social & customer-facing NLP",
    /* Remapped parent to own slug for Default Content. ray_menuStructure.ray. ray using AI Agent. 2026-07-13. Code Start */
    pagePath: "ch-7-real-world-applications-77-social-customer-facing-nlp",
    /* Code end. ray using AI Agent. 2026-07-13 */
    videoSrc: "videos/SocialMedia.mp4",
    captionsSrc: "subtitles/SEL-101 Social Media_1-caption.srt",
    showVideoToggle: true,
  },
  "ch-7-real-world-applications-77-social-customer-facing-nlp-social-media": {
    pageName: "Social Media",
    pagePath: "social-media",
    videoSrc: "videos/SocialMedia.mp4",
    captionsSrc: "subtitles/SEL-101 Social Media_1-caption.srt",
    showVideoToggle: true,
  },
  /* Code end. ray using AI Agent. 2026-07-10 (Ch 2-7) */
  /* Code end. ray using AI Agent. 2026-07-10 */
};
/* Code end. ray using AI Agent. 2026-07-10 */

/**
 * Chapters whose root click should land on a default section (not a chapter overview).
 * Empty: all chapters (including Ch 1) open their own description page like Ch 2–7.
 */
/* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-09. Code Start */
/* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
export const CHAPTER_DEFAULT_SECTIONS = {};
/* Code end. ray using AI Agent. 2026-07-10 */
/* Commenting the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Comment Start */
// export const CHAPTER_DEFAULT_SECTIONS = {
//   "/ch-1-foundation-years-1950s-2010s": {
//     sectionTitles: ["1.1 What is NLP?", "1.2 Applications of NLP"],
//     contentPaths: [
//       "/ch-1-foundation-years-1950s-2010s",
//       "/nlp-foundation",
//       "/whatis-NLP",
//       "/ch-1-foundation-years-1950s-2010s-12-applications-of-nlp",
//       "/overview-pointers-to-ch-7",
//     ],
//     highlightByPath: {
//       "/ch-1-foundation-years-1950s-2010s": "1.1 What is NLP?",
//       "/nlp-foundation": "1.1 What is NLP?",
//       "/whatis-NLP": "What is NLP",
//       "/ch-1-foundation-years-1950s-2010s-12-applications-of-nlp": "1.2 Applications of NLP",
//       "/overview-pointers-to-ch-7": "Overview + pointers to Ch 7",
//     },
//   },
// };
/* Commenting end. ray using AI Agent. 2026-07-10 */

/**
 * Optional overrides: folder click navigates to a different path than the folder slug.
 * Empty by default — folders open their own simple description page at /{slug}.
 */
/* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
export const SECTION_NAV_TARGETS = [];

export function resolveSectionNavTarget() {
  return null;
}

export const SECTION_NAV_CONFIG = {};
/* Code end. ray using AI Agent. 2026-07-10 */
/* Code end. ray using AI Agent. 2026-07-09 */
/* Code end. ray using AI Agent. 2026-07-07 */
